export default __webpack_public_path__ + "static/media/stripe-success.be084d29.png";